import { Container, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import PaymentDone from "../assets/images/payment_ok.svg";
import { useParams } from "react-router-dom";
import { usePaymentCheck } from "../hooks/payment/usePaymentCheck";
import { useUserAuth } from "../context/UserAuthContext";
import { useTranslation } from "react-i18next";

const PaymentConfirmation = () => {
  const { userId } = useParams();
  const { checkPayment } = usePaymentCheck();
  const { reloadUserData } = useUserAuth();
  const { t } = useTranslation();

  useEffect(() => {
    if (userId) {
      checkPayment(userId).then(() => {
        reloadUserData();
      });
    }
  }, [userId]);

  return (
    <Container>
      <Grid container height={"50vh"}>
        <Grid
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          item
          flexDirection={"column"}
          xs={12}
        >
          <Typography padding={1} color={"primary"} variant="h1">
            Welcome home!
          </Typography>
          <Typography padding={1} variant="subtitle2" dangerouslySetInnerHTML={{ __html: t("createdProfile.premium.text") }} />
        </Grid>
        <Grid
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          item
          xs={12}
        >
          <img height={400} alt="Payment done" src={PaymentDone} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default PaymentConfirmation;
